<style lang="scss" scoped>

.modal-font {
  font-family: system-ui;
  font-weight: 300;
  color: #141413;
}

.container {
  display: flex;
  flex-direction: column;
  padding: 17px;
  border-radius: 10px;
}
.clicktopay-close-btn {
    display: inline-block;
    width: 22px;
    background-image: url('../../../../src/assets/images/close.png');
    background-repeat: no-repeat;
    margin: 5px;
    height: 22px;
    cursor: pointer;
    border: none;
    background-color: transparent;
  }

  .clicktopay {
    font-size: 36px;
    margin-bottom: 16px;
    font-weight: bold;
  }

  .container-header{
   display: flex;
   justify-content: space-between;
  }

  .clicktopay-header {
    line-height:1.5rem;
    font-size: 1rem;
    margin-bottom: 8px;
    margin-right: 5px;
    word-break: break-word;
  }

  .clicktopay-items {
    padding-left: 5px;
    font-size: 1rem;
    margin-bottom: 16px;
  }
  .clicktopay-icon {
    padding: 10px 0px;
  }

  .color-orange-high {
    color: #FF3A00;
  }
  .btn-align {
    text-align: center;
  }

  .mastercard-logo {
    width: 35px;
    height: 16px;
  }

  .visa-logo {
    width: 35px;
    height: 16px;
  }

</style>
<script>
import { SDK_ID_MASTERCARD } from '@/utils/constant'

export default {
  name: 'SRCLearnMoreComponent',

  props: {
    cardbrand: Array,
    displayokbutton: Boolean
  },
  data () {
    return {
      loadedSDKs: [SDK_ID_MASTERCARD],
      isVisibleOKButton: false
    }
  },

  created () {
    this.loadedSDKs = this.cardbrand
    this.isVisibleOKButton = this.displayokbutton
  },

  methods: {
    hideClick2PayModal () {
      this.$emit('close')
    }
  }
}
</script>

<template>
  <div class="container">
    <div class="container-header">
      <div>
        <h1 class="modal-font clicktopay">{{ $t ('clickToPayModal.welcomeTo') }}<br><span class="color-orange-high">{{ $t ('clickToPayModal.clickToPay') }}</span></h1>
      </div>
      <div
        class="col-1 p-0"
        @click="hideClick2PayModal">
        <button
          aria-label="Close"
          type="button"
          class="clicktopay-close-btn"/>
      </div>
    </div>
    <div class="margin-bottom-sm">
      <div>
        <h2 class="modal-font clicktopay-header">{{ $t ('clickToPayModal.clickToPayMessage') }}</h2>
        <div class="clicktopay-icon">
          <div class="d-inline">
            <img
              class="src-logo"
              src="@/assets/images/src-networks/src_logo.png"
            >
          </div>
          <div
            v-for="(sdk,index) in loadedSDKs"
            :key="index"
            class="d-inline"
          >
            <img
              :class="sdk+'-logo'"
              :src="require('@/assets/images/src-networks/' + sdk+'.svg')"
              class="mr-1"
            >
          </div>
        </div>
        <div class="col align-left">
          <ul class="modal-font clicktopay-items">
            <li>
              <p
                data-test="list-item-first"
              >{{ $t ('clickToPayModal.line1') }}</p>
            </li>
            <li>
              <p
                data-test="list-item-second"
              >{{ $t ('clickToPayModal.line2') }}</p>
            </li>
            <li>
              <p
                data-test="list-item-third"
              >{{ $t ('clickToPayModal.line3') }}</p>
            </li>
          </ul>
        </div>
        <div
          v-if="isVisibleOKButton"
          class="btn-align">
          <button
            id="add-card-btn"
            class="btn btn-dark lightbox-btn btn-lg"
            data-test="btn-continue"
            type="submit"
            @click="hideClick2PayModal"
          >
            {{ $t ('clickToPayModal.okLabel') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
